<div class="dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-top">
      <div class="header-title-group">
        <div class="header-icon">
          <mat-icon fontSet="material-icons-outlined">account_tree</mat-icon>
        </div>
        <div>
          <div class="header-title">{{ data.schema.label }}</div>
          <div class="header-subtitle">{{ 'catalog.detail.dataModel.subtitle' | transloco }}</div>
        </div>
        <span class="format-badge" [class.format-json]="data.schema.format === 'json'" [class.format-xml]="data.schema.format === 'xml'">
          {{ data.schema.format }}
        </span>
      </div>
      <button class="close-btn" (click)="close()" aria-label="Close">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Variant Selector -->
  @if (hasVariants) {
    <div class="variant-selector">
      @for (variant of variants; track variant.name; let i = $index) {
        <button
          class="variant-btn"
          [class.active]="activeVariantIndex() === i"
          (click)="selectVariant(i)"
        >
          {{ variant.name }}
        </button>
      }
    </div>
    @if (activeVariantDescription()) {
      <div class="variant-description">{{ activeVariantDescription() }}</div>
    }
  }

  <!-- Toolbar -->
  <div class="toolbar">
    <div class="search-field">
      <mat-icon class="search-icon" fontSet="material-icons-outlined">search</mat-icon>
      <input
        type="text"
        [placeholder]="'catalog.detail.dataModel.search' | transloco"
        [ngModel]="searchTerm()"
        (ngModelChange)="onSearchInput($event)"
      />
    </div>
    <div class="toolbar-actions">
      <button class="toolbar-btn" (click)="allExpanded ? collapseAll() : expandAll()">
        <mat-icon fontSet="material-icons-outlined">{{ allExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        {{ 'catalog.detail.dataModel.expandAll' | transloco }}
      </button>
    </div>
    <div class="attr-count">
      <strong>{{ totalAttributes() }}</strong> {{ 'catalog.detail.dataModel.attributes' | transloco }}
    </div>
  </div>

  <!-- Tree Content -->
  <div class="tree-scroll">
    <app-data-model-tree-node
      [node]="activeRoot()"
      [searchTerm]="searchTerm()"
      [expandedNodes]="expandedNodes()"
      [isRoot]="true"
      (toggleExpand)="onToggleExpand($event)"
    />

    @if (searchTerm() && !matchesAny()) {
      <div class="no-results">
        <mat-icon fontSet="material-icons-outlined">search_off</mat-icon>
        <p>{{ 'catalog.detail.dataModel.noResults' | transloco }}</p>
        <span>{{ 'catalog.detail.dataModel.noResultsHint' | transloco }}</span>
      </div>
    }
  </div>

  <!-- Legend -->
  <div class="legend">
    <div class="legend-item"><div class="legend-swatch swatch-string"></div>string</div>
    <div class="legend-item"><div class="legend-swatch swatch-number"></div>number</div>
    <div class="legend-item"><div class="legend-swatch swatch-date"></div>date</div>
    <div class="legend-item"><div class="legend-swatch swatch-boolean"></div>boolean</div>
    <div class="legend-item"><div class="legend-swatch swatch-object"></div>object</div>
    <div class="legend-item"><div class="legend-swatch swatch-array"></div>array</div>
    <div class="legend-item legend-required"><span class="required-mark">*</span> {{ 'catalog.detail.dataModel.requiredField' | transloco }}</div>
  </div>
</div>
